import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiResponse } from 'model/response-model';
import { AddAutoSavingModel, AddPhoneCharge, AutoSavingModel, CompanySalaryDisbursementChargeDto, GeneralSalaryDisbursementChargeDto, Item, PayrollVendorChargeBasis, PayrollVendorChargeModel, PayrollVendorUpdate, PhoneChargeModel, PhoneChargeQuery, UpdateAutoSavingModel, UpdatePhoneCharge } from 'model/rule-engine-model';
import { GeneralOtpModel } from 'model/generalOtpModel';
import { baseQueryWithReauth } from './config/interceptor';

const basePath = 'RuleEngine';

// Define a service using a base URL and expected endpoints
export const subscriptionApi = createApi({
  reducerPath: 'subscriptionApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Subscription'],
  endpoints: (builder) => ({
    //Salary Disbursement API
    updateGeneralSalary: builder.mutation<ApiResponse<string>, GeneralSalaryDisbursementChargeDto>({
      query: (credentials) => ({
        url: `${basePath}/salary-disbursement-charge/general`,
        method: 'PATCH',
        body: credentials,
      }),
    }),
    getGeneralSalary: builder.query<ApiResponse<GeneralSalaryDisbursementChargeDto>, void>({
      query: () => ({
        url: `${basePath}/salary-disbursement-charge/general`
      }),
    }),
    getCompaniesSalary: builder.query<ApiResponse<Item>, void>({
      query: () => ({
        url: `${basePath}/salary-disbursement-charge/companies`
      }),
    }),
    getCompaniesSalaryPeriod: builder.query<ApiResponse<CompanySalaryDisbursementChargeDto>, void>({
      query: (id) => ({
        url: `${basePath}/salary-disbursement-charge/companies/${id}/period/chargeDeductionPeriod`
      }),
    }),
    updateCompaniesSalary: builder.mutation<ApiResponse<string>, [GeneralSalaryDisbursementChargeDto, string]>({
      query: ([credentials, id]) => ({
        url: `${basePath}/salary-disbursement-charge/companies/${id}`,
        method: 'PATCH',
        body: credentials
      }),
    }),
    //Payroll Vendor Charge API 
    getPayrollVendorChargeBasis: builder.query<ApiResponse<PayrollVendorChargeBasis[]>, void>({
      query: () => ({
        url: `${basePath}/payroll-vendor-charge/charge-deduction-basis`
      }),
    }), 
    addPayrollVendorChargeBasis: builder.mutation<ApiResponse<string>, PayrollVendorUpdate>({
      query: (name) => ({
        url: `${basePath}/payroll-vendor-charge/charge-deduction-basis${name}`,
        method: 'POST',
      }),
    }),
    getPayrollVendorCharge: builder.query<ApiResponse<PayrollVendorChargeModel>, void>({
      query: () => ({
        url: `${basePath}/payroll-vendor-charge`
      }),
    }),    
    updatePayrollVendorCharge: builder.mutation<ApiResponse<string>, PayrollVendorUpdate>({
      query: (credentials) => ({
        url: `${basePath}/payroll-vendor-charge`,
        method: 'PATCH',
        body: credentials
      }),
    }),
    //Rule Engine Autsaving Api
    
    addAutoSaving: builder.mutation<ApiResponse<string>, AddAutoSavingModel>({
      query: (credentials) => ({
        url: `${basePath}/auto-saving`,
        method: 'POST',
      }),
    }),
    getAutoSaving: builder.query<ApiResponse<AutoSavingModel[]>, void>({
      query: () => ({
        url: `${basePath}/auto-saving`
      }),
    }),    
    updateAutoSaving: builder.mutation<ApiResponse<string>, UpdateAutoSavingModel>({
      query: (credentials) => ({
        url: `${basePath}/auto-saving`,
        method: 'PATCH',
        body: credentials
      }),
    }),
    validateGeneralOtp: builder.mutation<ApiResponse<string>, [GeneralOtpModel, string]>({
      query: ([credentials, otpType]) => ({
        url: `Otp/sms/${otpType}`,
        method: 'POST',
        body: credentials
      }),
    }),
    getPhoneCharge: builder.query<ApiResponse<PhoneChargeModel>, PhoneChargeQuery>({
      query: (data) => ({
        url: `${basePath}/phone-charge/${data?.chargeType}/${data?.pageIndex}`
      }),
    }),
    addPhoneCharge: builder.mutation<ApiResponse<string>, AddPhoneCharge>({
      query: (credentials) => ({
        url: `${basePath}/phone-charge`,
        method: 'POST',
        body: credentials
      }),
    }),  
    updatePhoneCharge: builder.mutation<ApiResponse<string>, UpdatePhoneCharge>({
      query: (credentials) => ({
        url: `${basePath}/phone-charge`,
        method: 'PATCH',
        body: credentials
      }),
    }),  
    getWaitlister: builder.query<ApiResponse<string>, void>({
      query: () => ({
        url: `https://api.jobpro.app/cv/api/identity/getwaitinglist`,
      })
    })
  }),
});

// Export the auto-generated hooks
export const {
  useGetGeneralSalaryQuery,
  useGetCompaniesSalaryQuery,
  useGetCompaniesSalaryPeriodQuery,
  useUpdateCompaniesSalaryMutation,
  useUpdateGeneralSalaryMutation,
  useGetPayrollVendorChargeBasisQuery,
  useAddPayrollVendorChargeBasisMutation,
  useGetPayrollVendorChargeQuery,
  useUpdatePayrollVendorChargeMutation,
  useAddAutoSavingMutation,
  useGetAutoSavingQuery,
  useUpdateAutoSavingMutation,
  useValidateGeneralOtpMutation,
  useAddPhoneChargeMutation,
  useGetPhoneChargeQuery,
  useUpdatePhoneChargeMutation
} = subscriptionApi;
